import { Stack } from 'expo-router';
import { shallow } from 'zustand/shallow';
import Box from '@/components/UI/Box';
import RadioGroup from '@/components/UI/RadioGroup';
import Text from '@/components/UI/Text';
import useThemeStore from '@/stores/useThemeStore';

type ThemeItemValue = 'system' | 'light' | 'dark';

const themeItems: Array<{ title: string; value: ThemeItemValue }> = [
  {
    title: 'System',
    value: 'system',
  },
  {
    title: 'Light',
    value: 'light',
  },
  {
    title: 'Dark',
    value: 'dark',
  },
];

export default function ProfileAppearance() {
  const [theme, setTheme] = useThemeStore(
    (state) => [state.theme, state.setTheme],
    shallow,
  );

  const onValueChange = (value: string) => {
    if (value === 'system' || value === 'light' || value === 'dark') {
      setTheme(value);
    }
  };

  return (
    <>
      <Stack.Screen options={{ title: 'Appearance' }} />
      <Box direction="vertical" space="xs" p="lg">
        <Text bold size="xl">
          Theme
        </Text>
        <RadioGroup value={theme} onValueChange={onValueChange} size="lg">
          {themeItems.map((item) => (
            <RadioGroup.Option
              key={item.value}
              value={item.value}
              accessibilityLabel={item.title}
            >
              <Text>{item.title}</Text>
            </RadioGroup.Option>
          ))}
        </RadioGroup>
      </Box>
    </>
  );
}
